export const USER_SEARCH_TYPE = 'collector';
export const USER_SEARCH_LIMIT = 9;

export function createUserSearchQuery(searchTerm) {
  return {
    q: typeof searchTerm === 'string' ? searchTerm : '',
    user_type: USER_SEARCH_TYPE,
    limit: USER_SEARCH_LIMIT,
  };
}

export function getUserSearchListMetrics(viewportWidth) {
  const isMobile = viewportWidth <= 550;

  return {
    gap: viewportWidth <= 360 ? 8 : viewportWidth <= 480 ? 10 : 15,
    // Matches the row's avatar height plus its vertical padding in Row.css.
    rowHeight: isMobile ? 80 : 90,
  };
}
